var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserRole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8319 4.21347C12.8319 6.54051 11.1163 8.42694 9 8.42694C6.88367 8.42694 5.16805 6.54051 5.16805 4.21347C5.16805 1.88644 6.88367 0 9 0C11.1163 0 12.8319 1.88644 12.8319 4.21347ZM11.5546 4.21347C11.5546 5.76483 10.4109 7.02245 9 7.02245C7.58911 7.02245 6.44536 5.76483 6.44536 4.21347C6.44536 2.66211 7.58911 1.40449 9 1.40449C10.4109 1.40449 11.5546 2.66211 11.5546 4.21347Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5337C4.86508 10.5337 1.34202 13.2222 0 16.9887C0.326926 17.3457 0.671318 17.6833 1.03164 18C2.03098 14.5419 5.16595 11.9382 9 11.9382C12.834 11.9382 15.969 14.5419 16.9684 18C17.3287 17.6834 17.6731 17.3457 18 16.9888C16.658 13.2222 13.1349 10.5337 9 10.5337Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRole);
export default __webpack_public_path__ + "static/media/user_role.d1611d259479e8247a9aa4cf8431a7a0.svg";
export { ForwardRef as ReactComponent };